var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-toaster" },
    _vm._l(_vm.messages, function(message) {
      return _c(message.component, {
        key: message.id,
        tag: "component",
        attrs: { message: message }
      })
    })
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }